import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

export function GetStartedFAQ() {
  const { language } = useLanguage();

  const faqs = [
    {
      question: language === 'es' 
        ? '¿Qué tipos de procesos se pueden automatizar con inteligencia artificial?'
        : 'What types of processes can be automated with artificial intelligence?',
      answer: language === 'es'
        ? 'Podemos automatizar una amplia gama de procesos empresariales, desde atención al cliente hasta análisis de datos y operaciones logísticas.'
        : 'We can automate a wide range of business processes, from customer service to data analysis and logistics operations.'
    },
    {
      question: language === 'es'
        ? '¿Cómo afectará la automatización a mis empleados?'
        : 'How will automation affect my employees?',
      answer: language === 'es'
        ? 'La automatización libera a tus empleados de tareas repetitivas, permitiéndoles enfocarse en actividades más estratégicas y de mayor valor.'
        : 'Automation frees your employees from repetitive tasks, allowing them to focus on more strategic and higher-value activities.'
    },
    {
      question: language === 'es'
        ? '¿Qué tan segura es la automatización de procesos para mi empresa?'
        : 'How secure is process automation for my company?',
      answer: language === 'es'
        ? 'Implementamos las más altas medidas de seguridad y cumplimos con todos los estándares de protección de datos.'
        : 'We implement the highest security measures and comply with all data protection standards.'
    }
  ];

  return (
    <div className="space-y-6">
      {faqs.map((faq, index) => (
        <div key={index} className="bg-gray-50 rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">{faq.question}</h3>
          <p className="text-gray-600">{faq.answer}</p>
        </div>
      ))}
    </div>
  );
}